const webStorageKeys = {
	'ME_PAGE_SHOW_BACK': 'me-page-show-back',
	'ROUTER_COMMON_BACK': 'router:common',
	'ROUTER_MESSAGE_BACK': 'router:message-back',
	'ROUTER_MY_BETS_BACK': 'router:my-bets-back',
	'ROUTER_HISTORY_BACK': 'router:history-back',
	'ROUTER_RESULT_BACK': 'router:result-back',
	'ROUTER_HOW_TO_USE_BACK': 'router:how-to-use-back',
	'ROUTER_CONTACT_US_BACK': 'router:contact-us-back',
	'HAS_SHOWN_NEWBIE_TUTORIAL_INFO': 'persist:has-shown-newbie-tutorial-info',
	'HAS_SHOWN_MARS_UPDATE_TOOLTIP_IN_APPBAR': 'persist:has-shown-mars-update-tooltip-in-appbar',
	'HAS_SHOWN_MARS_UPDATE_TOOLTIP_IN_HEADER': 'persist:has-shown-mars-update-tooltip-in-header',
	'IS_SHOW_REVISION_NOTICE': 'persist:is-show-revision-notice',
	'FLOATSTREAMER': 'floatStreamer',
	'HAS_SHOWN_BACK_TO_MATCH_TIP': 'persist:has-shown-back-to-match-tip',
	'HAS_SHOWN_OLD_STATEMENT_ALERT': 'persist:has-shown-old-statement_alert',
	'HAS_SHOWN_MARS_REVISION_TOOLTIP': 'persist:has-shown-mars-revision-tooltip',
	'HAS_SHOWN_UPDATE_BETTYPE_1X2_ORDER_POPUP': 'persist:has-shown-update-bettype-1x2-order-popup',
	'HAS_SHOWN_GOLDEN_DUAL_TOOLTIP': 'persist:has-shown-golden-dual-tooltip',
	'GOLDEN_DUAL_TRANS': 'persist:golden-dual-trans',
	'GOLDEN_DUAL_DRAW_TIME': 'persist:golden-dual-draw-time',
	'GOLDEN_DUEL_PROMO_TRIGGERED': 'persist:is-golden-duel-promo-triggered',
	'HAS_SHOWN_CWC_JACKPOT_TOOLTIP': 'persist:has-shown-cwc-jackpot-tooltip',
	'CWC_JACKPOT_TRANS': 'persist:cwc-jackpot-trans',
	'CWC_JACKPOT_DRAW_TIME': 'persist:cwc-jackpot-draw-time',
	'HAS_COMPLETED_NBA_SURVEY': 'persist:has-completed-nba-survey',
	'HAS_DISMISSED_REWARD_ANNOUNCEMENT_MODAL': 'persist:has-dismissed-reward-announcement-modal',
	'WC_PROMOTION_AFTER_PARTY_TICKETS_VIEWED': 'persist:wc-promotion-after-party-tickets-viewed',
	'WC_PROMOTION_TRANS': 'persist:wc-promotion-trans',
	'WC_PROMOTION_VIP_MODAL_LAST_DISMISSED_AT_PREFIX': 'persist:wc-promotion-vip-modal-last-dismissed-at',
	'WC_PROMOTION_VIP_BETSLIP_HINT_WEEK_PREFIX': 'persist:wc-promotion-vip-betslip-hint-week',
	'PROMOTION_ACTIVITY_MODAL_CLOSED': 'promotion-activity-modal-closed',
	'AFFILIATE_BTAG': 'affiliate-btag',
} as const;

export default webStorageKeys;
